import React from 'react'
import { connect } from 'react-redux'
import InventoryActions from '../../Redux/InventoryRedux'
import FileUploader from '../FileUploader'
import FilesActions from '../../Redux/FilesRedux'

class ManageInventoryImage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        image1: null,
        image2: null,
        image3: null,
        image4: null,
        image5: null
      },
      image_type: '',
      file: null,
      uploaded: false
    }
  }

  componentDidMount = () => {
    this.props.resetFile()
  }

  componentWillReceiveProps = (newProps) => {
    if (newProps.files.data) {
      let form = {...this.state.form}
      form.image1 = newProps.files.data.upload[0].filename
      form.image2 = newProps.files.data.upload[0].filename
      form.image3 = newProps.files.data.upload[0].filename
      form.image4 = newProps.files.data.upload[0].filename
      form.image5 = newProps.files.data.upload[0].filename
    }
  }

  _upload = (event) => {
    event.preventDefault()
    let data = new FormData()
    data.append('files', this.state.file.files[0])
    data.append('type', 'inventory')
    data.append('image_type')
    this.props.upload(data)
    this.setState({ uploaded: true })
  }

  _fileUploaded = (filename, field) => {
    let form = {...this.state.form}
    form[field] = filename
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = {...this.state.form}
    const data = {
      id: this.props.detail.id,
      form
    }
    this.props.updateInventoryImage(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '50vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Edit Inventory Image</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label htmlFor='image' className='control-label'>Image 1</label>
            </div>
            <div className='col-9'>
              <FileUploader required setting={{ type: 'inventory', image_type: 'image' }} onUploaded={(filename) => this._fileUploaded(filename, 'image1')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label htmlFor='image' className='control-label'>Image 2</label>
            </div>
            <div className='col-9'>
              <FileUploader setting={{ type: 'inventory', image_type: 'image' }} onUploaded={(filename) => this._fileUploaded(filename, 'image2')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label htmlFor='image' className='control-label'>Image 3</label>
            </div>
            <div className='col-9'>
              <FileUploader setting={{ type: 'inventory', image_type: 'image' }} onUploaded={(filename) => this._fileUploaded(filename, 'image3')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label htmlFor='image' className='control-label'>Image 4</label>
            </div>
            <div className='col-9'>
              <FileUploader setting={{ type: 'inventory', image_type: 'image' }} onUploaded={(filename) => this._fileUploaded(filename, 'image4')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label htmlFor='image' className='control-label'>Image 5</label>
            </div>
            <div className='col-9'>
              <FileUploader setting={{ type: 'inventory', image_type: 'image' }} onUploaded={(filename) => this._fileUploaded(filename, 'image5')} />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button className='btn btn-primary' type='submit'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  files: state.files
})

const dispatchToProps = (dispatch) => ({
  upload: (data) => dispatch(FilesActions.filesUploadRequest(data)),
  resetFile: () => dispatch(FilesActions.filesUploadReset()),
  updateInventoryImage: (data) => dispatch(InventoryActions.updateInventoryImageRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ManageInventoryImage)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/ManageInventoryImage.js